<template>
  <v-sheet :color="$vuetify.theme.dark ? '#162334 ' : '#E8F1F8'">
    <v-container class="main-container mt-7">
      <v-row dense>
        <v-col cols="12">
          <div class="titleName mb-5 mt-3 d-flex align-center justify-space-between">
            <div class="d-flex align-center">
              <v-img class="mr-3" max-width="18" src="@/assets/Dashboard/bar.svg"></v-img>
              <span>Top Performed IB</span>
            </div>
            <div>
              <router-link class="links" to="/top-performed-ib">See All Top IB></router-link>
            </div>
          </div>
        </v-col>
        <v-col cols="12">
          <TopIBClientsTable></TopIBClientsTable>
        </v-col>
      </v-row>
    </v-container>
  </v-sheet>
</template>

<script>
import TopIBClientsTable from "./TopIBClientsTable.vue";
export default {
  data: () => ({}),
  components: {
    TopIBClientsTable,
  },
};
</script>
